import React from 'react'
import { Link } from 'react-router-dom'

export default function PendingChildrenItem({data, srNo}) {
  const creationDate = new Date(data.created_at);
  return (
    <tr>
        <td className='ps-3 py-2'>
            {srNo}
        </td>
        <td className='py-2'>
            {data.firstName+' '+data.lastName}
        </td>
        <td className='py-2'>
            {data.user.firstName+' '+data.user.lastName}
        </td>
        <td className='py-2'>
            {creationDate.getDate()+'-'+(creationDate.getMonth()+1)+'-'+creationDate.getFullYear()}
        </td>
        <td className='text-end pe-3 py-3'>
            <Link to={`/children/${data.childId}`} className='link-btn link-font-size'>View</Link>
        </td>
    </tr>
  )
}
